import React from "react";
import AnswerChip from "./AnswerChip";

export default function GridAnswer({ answer, answeres }) {
  return (
    <div className="answerArea">
      <div
        className="bg-white rounded-2xl p-3 shadow-sm"
        style={{ width: "280px" }}
      >
        {answer?.question?.gridRows?.map((gridRow) => {
          const rowAnswer =
            answeres[answer?.question?._id]?.value?.[gridRow._id];
          if (!rowAnswer) return null;

          // Handle both single selection (radio) and multi-selection (checkbox)
          const selectedOptions = Array.isArray(rowAnswer)
            ? rowAnswer
            : [rowAnswer];
          const selectedTexts = selectedOptions
            .map((optionId) => {
              const option = answer?.question?.options?.find(
                (opt) => opt._id === optionId
              );
              return option?.text;
            })
            .filter(Boolean);

          if (selectedTexts.length === 0) return null;

          return (
            <div key={gridRow._id} className="mb-2 last:mb-0">
              <div
                className="text-xs font-medium text-gray-600 mb-1"
                style={{ textAlign: "left" }}
              >
                {gridRow.text}
              </div>
              <div className="flex flex-wrap gap-1">
                {selectedTexts.map((text, index) => (
                  //   <Chip
                  //     key={index}
                  //     label={text}
                  //     variant="outlined"
                  //     size="small"
                  //     className="chip"
                  //     classes={{
                  //       root: classes.chipRoot,
                  //       label: classes.chipLabel,
                  //     }}
                  //   />
                  <AnswerChip label={text || ""} key={index} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
